import { cn } from "@/lib/utils";

interface MobileJobTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  jobType?: string;
}

export const MobileJobTabs = ({ activeTab, onTabChange, jobType }: MobileJobTabsProps) => {
  const tabs = jobType === "Insurance" 
    ? ["Overview", "Photo Hub", "Measurement/Estimate", "Supplements", "Communications"]
    : jobType === "Commercial"
    ? ["Overview", "Photo Hub", "Quick Estimate", "Proposals", "Communications"]
    : ["Overview", "Photo Hub", "Measurement/Estimate", "Proposals", "Communications"];

  return (
    <div className="sticky bottom-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-t shadow-lg">
      <div className="flex overflow-x-auto no-scrollbar">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            className={cn(
              "flex-1 min-w-[100px] px-2 py-4 text-[10px] font-semibold transition-colors whitespace-nowrap leading-tight",
              activeTab === tab
                ? "text-primary border-b-2 border-primary bg-primary/5"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};
